module.exports = __webpack_public_path__ + "img/head1.86fee5b0.png";